import { Component, HostListener, OnInit } from '@angular/core';
import { TimerToLock } from './timer-to-lock';

@Component({
    selector: 'pz-lock-page',
    templateUrl: './lock-page.component.html',
    styleUrls: ['./lock-page.component.scss']
})
export class LockPageComponent implements OnInit {
    public constructor( public lock: TimerToLock) {
    }

    public ngOnInit() {
        //
    }

}
